'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.xhrSend = xhrSend;
exports.beaconSend = beaconSend;
function xhrSend(apiUrl, data) {

    var xhr = new XMLHttpRequest();
    xhr.open('POST', apiUrl);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(data);
}

function beaconSend(apiUrl, encodedData) {
    var beacon = new Image(1, 1);
    beacon.src = apiUrl + "?data=" + encodedData;
}


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/lib/dataDispatcher.js